import "../../App.css";
import "../../styling/PreviousEvents.css";

// Bootstrap imports
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

import ReactFlipCard from "reactjs-flip-card";
import March25Image from "../../images/gallery/THATShow-March30-OwenBurnham-42.jpg";
import Dec24Image from "../../images/gallery/smile_THATShowDec_OwenBurnham-06.jpg";
import Dec25Show from "../../images/events/dec_12_15_show.jpg";
// import Sep24Image from "../../images/gallery/20240921_FuckItBopIt-THATSHOWSept_OwenBurnham-10.jpg";
// import Apr24Image from "../../images/gallery/MackLawrence.LuluWest_THATshow_photoOwenBurnham-08.jpg";
import LongForm25Image from "../../images/events/IMG_5675.jpeg";

const card_styles = {
  card: {
    background: "#28204D",
    color: "white",
    borderRadius: 20,
    width: "100% !important",
  },
};

function PreviousEvents() {
  return (
    <Container className="tab_header">
      <Row className="tab_content">
        <h4>PREVIOUS EVENTS</h4>
        <Col sm={3} className="tab_content">
          <ReactFlipCard
            flipTrigger="onClick"
            frontStyle={card_styles.card}
            backStyle={card_styles.card}
            frontComponent={
              <div>
                <img
                  className="previous_event_image"
                  src={Dec25Show}
                  alt=""
                ></img>
                <h5>THAT SHOW</h5>
                <h6>December 12, 2025</h6>
              </div>
            }
            backComponent={
              <div style={{ marginLeft: "1vh", marginRight: "1vh" }}>
                <p
                  style={{
                    fontSize: "small",
                  }}
                >
                  Judson Memorial Church - “The Gym”<br></br>Washington Square S
                  <br></br>New York, NY 10012
                </p>
                <p>
                  Featuring works by Sophia Perone, Jarren Kolisnek, The Nadanam
                  Collective, Gesture Theater (Lou Sydel), Alexis Vinzons,
                  Manatsu Tanaka, and Cate Cameron
                </p>
              </div>
            }
          />
        </Col>
        <Col sm={3} className="tab_content">
          <ReactFlipCard
            flipTrigger="onClick"
            frontStyle={card_styles.card}
            backStyle={card_styles.card}
            frontComponent={
              <div>
                <img
                  className="previous_event_image"
                  src={LongForm25Image}
                  alt=""
                ></img>
                <h5>
                  THAT SHOW<br></br>(Long Form)
                </h5>
                <h6>August 21-22 & September 25-26, 2025</h6>
              </div>
            }
            backComponent={
              <div style={{ marginLeft: "1vh", marginRight: "1vh" }}>
                <p
                  style={{
                    fontSize: "small",
                  }}
                >
                  Judson Memorial Church - “The Gym”<br></br>Washington Square S
                  <br></br>New York, NY 10012
                </p>
                <p
                  style={{
                    fontSize: "small",
                  }}
                >
                  <b>
                    <i>
                      "the discotech is where i go to experience unmatched joy
                      and profound sadness"
                    </i>
                  </b>
                  &nbsp;&nbsp;created by PETER ALFRED ELIZALDE
                  <br></br> <br></br>
                  <b>
                    <i>"train" </i>
                  </b>
                  &nbsp;&nbsp;created by EM PAPINEAU + SOFIA ENGELMAN
                  <br></br> <br></br>
                  <b>
                    <i>"Ecdysis" </i>
                  </b>
                  &nbsp;&nbsp;created by ALICIA STEEVES
                  <br></br> <br></br>
                  <b>
                    <i>"Mom Always Liked You Best" </i>
                  </b>
                  &nbsp;&nbsp;created by RACHEL HA-EUN LEE + STEPHANIE SHIN
                </p>
              </div>
            }
          />
        </Col>
        <Col sm={3} className="tab_content">
          <ReactFlipCard
            flipTrigger="onClick"
            frontStyle={card_styles.card}
            backStyle={card_styles.card}
            frontComponent={
              <div>
                <img
                  className="previous_event_image"
                  src={March25Image}
                  alt=""
                ></img>
                <h5>
                  THAT SHOW<br></br>(Classic)
                </h5>
                <h6>March 29-30, 2025</h6>
              </div>
            }
            backComponent={
              <div style={{ marginLeft: "1vh", marginRight: "1vh" }}>
                <p
                  style={{
                    fontSize: "small",
                  }}
                >
                  Gracemoon Arts<br></br>13 Grattan St, Cellar
                  <br></br>
                  Brooklyn, NY 11206
                </p>
                <p>
                  Featuring works by Audrey Allen, Hannah Dolen, Uhaul
                  Entertainment, Justine Florence, Paolina Gonzales & Rae Su,
                  Brandon Rumaker, Mae B. Tomorrow, Rachel Calabrese & Emmy
                  Wildermuth, Morgan Cogley, Neva Guido, Rush Johnston, Dahyun
                  Kim, Kassandra & Josie Kolbeck, Safiya Vanterpool
                </p>
              </div>
            }
          />
        </Col>
        <Col sm={3} className="tab_content">
          <ReactFlipCard
            flipTrigger="onClick"
            frontStyle={card_styles.card}
            backStyle={card_styles.card}
            frontComponent={
              <div>
                <img
                  className="previous_event_image"
                  src={Dec24Image}
                  alt=""
                ></img>
                <h5>
                  THAT SHOW<br></br>(Classic)
                </h5>
                <h6>December 14, 2024</h6>
              </div>
            }
            backComponent={
              <div style={{ marginLeft: "1vh", marginRight: "1vh" }}>
                <p
                  style={{
                    fontSize: "small",
                  }}
                >
                  Index<br></br>120 Walker St, Fl 3<br></br>New York, NY 10013
                </p>
                <p>
                  Featuring works by Taylor Adams, Camilia Araque, Lindsey
                  Jennings, Emily Schwartz, Ashton Atteberry, Mirage Auto Depot,
                  Daniela & Gabby, go.co, Miles, Amanda Stambrosky
                </p>
                <a
                  style={{ color: "white" }}
                  href="https://www.dance-enthusiast.com/get-involved/reviews/view/Have-you-seen-THAT-SHOW-A-hub-for-movement-based-performance-art-in-NYC-December-14-2024"
                >
                  Link To Review
                </a>
              </div>
            }
          />
        </Col>
        {/* <Col sm={3} className="tab_content">
          <ReactFlipCard
            flipTrigger="onClick"
            frontStyle={card_styles.card}
            backStyle={card_styles.card}
            frontComponent={
              <div>
                <img
                  className="previous_event_image"
                  src={Sep24Image}
                  alt=""
                ></img>
                <h5>
                  THAT SHOW<br></br>(Classic)
                </h5>
                <h6>September 21, 2024</h6>
              </div>
            }
            backComponent={
              <div style={{ marginLeft: "1vh", marginRight: "1vh" }}>
                <p
                  style={{
                    fontSize: "small",
                  }}
                >
                  Index<br></br>120 Walker St, Fl 3<br></br>New York, NY 10013
                </p>
                <p>
                  Featuring works by Caroline Alter & Campbell Ives, Hillary
                  Bonhomme, Johnny Mathews III, Uila Marx & Rae Su, Stephanie
                  Shin, Natalia Sanchez, Murphy Severtson, Sheer Spectacle
                </p>
                <a
                  style={{ color: "white" }}
                  href="https://www.dance-enthusiast.com/features/impressions-reviews/view/That-Show-index-Space"
                >
                  Link To Review
                </a>
              </div>
            }
          />
        </Col> */}
        {/* <Col sm={3} className="tab_content">
          <ReactFlipCard
            flipTrigger="onClick"
            frontStyle={card_styles.card}
            backStyle={card_styles.card}
            frontComponent={
              <div>
                <img
                  className="previous_event_image"
                  src={Apr24Image}
                  alt=""
                ></img>
                <h5>
                  THAT SHOW<br></br>(Classic)
                </h5>
                <h6>April 27, 2024</h6>
              </div>
            }
            backComponent={
              <div style={{ marginLeft: "1vh", marginRight: "1vh" }}>
                <p
                  style={{
                    fontSize: "small",
                  }}
                >
                  Gracemoon Arts<br></br>13 Grattan St, Cellar
                  <br></br>
                  Brooklyn, NY 11206
                </p>
                <p>
                  Featuring works by Peter Alfred Elizalde, Sheila Jackson, Mack
                  Lawrence & Lulu West, Madi O’Halloran & Sumayyah Smith, Kimie
                  Parker, Adrienne Swan, Yolette A Yellow-Duke
                </p>
                <a
                  style={{ color: "white" }}
                  href="https://www.dance-enthusiast.com/features/impressions-reviews/view/That-Show-Index-Space-Taylor-Schmuelgen-Kayla-White"
                >
                  Link To Review
                </a>
              </div>
            }
          />
        </Col> */}
      </Row>
    </Container>
  );
}

export default PreviousEvents;
